var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('span',{staticClass:"white"},[_vm._v("智付系统商户自助管理平台")]),_vm._v(" "),_c('div',{staticClass:"logout",on:{"click":_vm.logout}},[_c('i',{staticClass:"white el-icon-switch-button"}),_vm._v(" "),_c('span',{staticClass:"white",attrs:{"slot":"title"},slot:"title"},[_vm._v("退出登录")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777378e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = null
// module chunks = 